import React, { Component } from 'react'
import { getRevDate } from '../common/helper'
import 'react-dates/initialize'
import { SingleDatePicker } from 'react-dates'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarDay } from '@fortawesome/free-solid-svg-icons'
import 'react-dates/lib/css/_datepicker.css'
import '../../css/common/datePicker.scss'
import moment from 'moment'

class Datepicker extends Component {
  constructor(props) {
    super(props)
    this.state = {
      depDate: moment(new Date(props.date)).isValid() ? moment(new Date(props.date)) : moment(new Date()),
      focused: false,
      isblur: true,
      labelClass: 'filled',
    }
  }

  // checkOutsideRange = (param, e) => {
  //   let today = new Date()
  //   today.setHours(0, 0, 0, 0)
  //   let ninety = new Date()
  //   let eventDate = e._d.setHours(0, 0, 0, 0)
  //   let dateDiff = this.props.dateDiff ? this.props.dateDiff : 90
  //   let range = ninety.setDate(ninety.getDate() - dateDiff)
  //   if (this.props.date) {
  //     const depDate = this.state.depDate._d
  //     return !(depDate <= e._d && range > e._d)
  //   } else {
  //     return !(range <= eventDate && today >= eventDate)
  //   }
  // }
  checkOutsideRange = (param, e) => {
    const { startDate: tempStartDate, endDate: tempEndDate } = this.props
    const startDate = moment(new Date(tempStartDate)).isValid() ? moment(new Date(tempStartDate)) : moment(new Date())
    const endDate = moment(new Date(tempEndDate)).isValid() ? moment(new Date(tempEndDate)) : moment(new Date())
    if (tempStartDate && tempEndDate) {
      const startOfDay = moment(e._d).startOf('day')
      return startOfDay.isBefore(startDate.startOf('day')) || startOfDay.isAfter(endDate.startOf('day'))
    } else {
      // If startDate and endDate are not provided, allow all dates before today or 90 days before today.
      const today = moment().startOf('day')
      const pastDate = moment(today).subtract(this.props.dateDiff || 90, 'days')
      return moment(e._d).startOf('day').isAfter(today) || moment(e._d).startOf('day').isBefore(pastDate)
    }
  }

  handlelabel = (e) => {
    if (this.props.statusChecked) {
      this.setState({ labelClass: 'filled' })
    } else {
      this.setState({ labelClass: 'active' })
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.focused) {
      const element = document.querySelector('.CalendarDay__selected')
      if (element) {
        setTimeout(() => {
          element.focus()
        }, 100)
      }
    }
  }
  render() {
    const { depDate } = this.state
    const initialVisibleMonth = depDate.clone().startOf('month')

    return (
      <>
        <div
          style={{ minWidth: this.props.minWidth, width: this.props.width }}
          className="input--content--datepicker"
          onClick={(e) => this.handlelabel(e)}
        >
          <div className="cal--icon left">
            <FontAwesomeIcon icon={faCalendarDay} size="lg" />
          </div>
          <SingleDatePicker
            id={this.props.id ? this.props.id : this.props.name}
            date={this.props.value ? this.props.value : this.state.depDate}
            onDateChange={(depDate) => {
              this.props.dateChange && this.props.dateChange(depDate)
              this.setState({ depDate, labelClass: 'filled' })
            }}
            focused={this.state.focused} // PropTypes.bool
            onFocusChange={({ focused }) => this.setState({ focused, labelClass: 'filled' })}
            hideKeyboardShortcutsPanel={true}
            block={true}
            numberOfMonths={1}
            noBorder={true}
            displayFormat="DD-MMM-YYYY"
            placeholder=""
            disabled={this.props.statusChecked ? true : false}
            isOutsideRange={(event) => this.checkOutsideRange(this.props.name, event)}
            anchorDirection="left"
            firstDayOfWeek={1}
            readOnly={true}
            initialVisibleMonth={() => initialVisibleMonth}
          />
          <div className={`date--label  ${this.state.labelClass}`}>
            {this.props.label}
            {this.props.star ? <span className="star">*</span> : ''}
          </div>
        </div>
      </>
    )
  }
}

export default Datepicker
